import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hourglass } from "lucide-react";
import { useAuth } from "@/lib/auth";

const msLeft = (iso) => Math.max(0, new Date(iso).getTime() - Date.now());

export default function TrialBanner() {
  const { user, refresh } = useAuth();
  const active = user?.role === "student" && user?.trial_active && user?.trial_ends_at;
  const [left, setLeft] = useState(active ? msLeft(user.trial_ends_at) : 0);

  useEffect(() => {
    if (!active) return undefined;
    const tick = () => {
      const ms = msLeft(user.trial_ends_at);
      setLeft(ms);
      if (ms <= 0) refresh();
    };
    tick();
    const t = setInterval(tick, 30000);
    return () => clearInterval(t);
  }, [active, user?.trial_ends_at, refresh]);

  if (!active) return null;
  const h = Math.floor(left / 3600000);
  const m = Math.floor((left % 3600000) / 60000);

  return (
    <div data-testid="trial-banner" className="bg-lemon/60 border-b-2 border-lemon">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-bold text-ink">
          <Hourglass className="w-4 h-4 shrink-0" />
          <span>Free trial: <span data-testid="trial-time-left">{h}h {m}m</span> left</span>
        </div>
        <Link to="/pending-approval" data-testid="trial-pay-now" className="px-4 py-1.5 rounded-full bg-watermelon text-white text-sm font-bold btn-tactile hover:bg-watermelon-hover">
          Pay now to keep learning
        </Link>
      </div>
    </div>
  );
}
